/**
 * Module dependencies.
 */

import { useBodyScroll } from '@untile/react-core/hooks/use-body-scroll';
import { ReactNode, RefObject } from 'react';
import { CSSTransition } from 'react-transition-group';
import { createReactPortal } from 'src/core/utils/portals';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
  isOpen: boolean;
  nodeRef: RefObject<HTMLElement | null>;
  preventBodyScroll: boolean;
};

/**
 * Export `ModalPortal` component.
 */

export function ModalPortal(props: Props) {
  const { children, isOpen, nodeRef, preventBodyScroll } = props;

  useBodyScroll({ off: preventBodyScroll });

  return createReactPortal(
    <CSSTransition in={isOpen} mountOnEnter nodeRef={nodeRef} timeout={300} unmountOnExit>
      {children}
    </CSSTransition>,
    'modal-root'
  );
}
